<template>
    <div>
        <v-progress-linear :color="payload.error ? 'error' : 'primary'" :model-value="progress"></v-progress-linear>
        <div class="pa-2">{{ content }}</div>
    </div>
</template>

<script>
export default {
    name: 'ProgressView',
    props: {
        payload: Object,
    },
    computed: {
        progress() {
            return this.payload.progress;
        },
        content() {
            return this.payload.content;
        },
    },
};
</script>

<style>

</style>
